<nav>
  <!-- <label class="label" for="arc">Use Case:</label> -->
  <div class="pure-button-group" id="arc">
    <button (click)="clickArcButton(arc.key)" *ngFor="let arc of arcs" [ngClass]="{'pure-button-selected': arc.key === getArc()}" class="pure-button">
      {{arc.text}}
    </button>
  </div>
  <!-- <label class="label" for="region">Region:</label> -->
  <div class="pure-button-group" id="region">
    <button (click)="clickRegionButton(region.key)" *ngFor="let region of regions" [ngClass]="{'pure-button-selected': region.key === getRegion()}" class="pure-button">
      {{region.text}}
    </button>
  </div>
  <!-- <label class="label" for="tabs">Tabs:</label> -->
  <div id="tabs">
  <a *ngFor="let page of pages" [routerLinkActiveOptions]="{exact: true}" [routerLink]="page.id" routerLinkActive="active">
    {{page.name}}
  </a>
  </div>
</nav>
